import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function MeProfile() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/me/profile").then(r => setData(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-4" data-testid="me-profile">
      <div>
        <div className="text-xs uppercase tracking-widest text-neutral-500">Profile</div>
        <h1 className="text-3xl font-bold mt-1">Your details</h1>
      </div>
      <Card className="border-0 shadow-sm">
        <CardContent className="p-6 grid md:grid-cols-2 gap-6">
          {[
            ["Full name", data?.user?.name],
            ["Email", data?.user?.email],
            ["Role in Alfred", data?.user?.role],
            ["Employee ID", data?.employee?.employee_id],
            ["Job title", data?.employee?.role_title],
            ["Department", data?.employee?.department],
            ["Location", data?.employee?.location],
            ["Employment status", data?.employee?.status],
          ].map(([k, v]) => (
            <div key={k}>
              <div className="text-xs uppercase tracking-widest text-neutral-500">{k}</div>
              <div className="mt-1 font-medium">{v || "—"}</div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
}
